module.exports = __webpack_public_path__ + "media/images/flags/dm-4ffb65574a5d638206edcc7dd9433979.svg";